import React from 'react';

import { contentBuilderPropTypes } from '../../utils/propTypes';

import ContentDisplay from './ContentDisplay';
import ContentEditor from './ContentEditor';

const propTypes = contentBuilderPropTypes.content;

const ImageContent = (props) => {

	const {
		data,
		resourceContent,
		isEditing,
		filestack,
		triggers,
		onCancel,
		onSave,
	} = props;

	const id = data.id;
	const type = data.type;
	const width = data.width;
	const scope = data.scope;
	const scopeId = data.scope_id;
	const showTitle = data.show_title;

	const initialValues = {
		title: resourceContent?.title,
		data: resourceContent?.data,
		width,
		language: data.language,
		resourceContents: data.resource_contents,
		deletedResourceContents: data.deleted_resource_contents,
	};

	return (
		<div>
			{isEditing &&
				<ContentEditor
					id={id}
					type={type}
					initialValues={initialValues}
					isNew={!data.created_at}
					filestack={filestack}
					onCancel={onCancel}
					onSave={onSave}
					onLanguageChange={triggers?.onLanguageChange}
					onWidthChange={triggers?.onWidthChange} />
			}
			{!isEditing &&
				<ContentDisplay
					id={id}
					title={resourceContent?.title}
					showTitle={showTitle}
					data={resourceContent?.data}
					width={width}
					scope={scope}
					scopeId={scopeId}
					onLinkClick={triggers?.onLinkClick} />
			}
		</div>
	);

};

ImageContent.propTypes = propTypes;

export default ImageContent;
